import _ from "lodash";
import store from "redux/store";
import { setViewerWebUrl } from "redux/webUrl/action";
import { emptyGameData } from "redux/gameParams/actions";
import { endGame, setGameName } from "redux/game/action";
import Socket from "socket/socket";

export const PATH_ARRAY = [
  "/gah",
  "/gahw",
  "/gahf",
  "/chpt",
  "/chptw",
  "/tw",
  "/vb",
  "/tot",
  "/flus",
  "/sk",
  "/dw20",
  "/och",
  "/ct",
  "/bng"
];

export const gameCodeHandler = (pathname) => {
  let gameCode;
  switch (pathname) {
    case "/gah":
      gameCode = "GAH";
      break;
    case "/gahw":
      gameCode = "GAHW";
      break;
    case "/gahf":
      gameCode = "GAHF";
      break;
    case "/chpt":
      gameCode = "CHPT";
      break;
    case "/chptw":
      gameCode = "CHPTW";
      break;
    case "/tw":
      gameCode = "TW";
      break;
    case "/vb":
      gameCode = "VB";
      break;
    case "/tot":
      gameCode = "TOT";
      break;
    case "/flus":
      gameCode = "FLUS";
      break;
    case "/sk":
      gameCode = "SK";
      break;
    case "/dw20":
      gameCode = "DW20";
      break;
    case "/och":
      gameCode = "OCH";
      break;
    case "/ct":
      gameCode = "CT";
      break;
    case "/bng":
      gameCode = "BNG";
      break;
    default:
      break;
  }
  return gameCode;
};

export const getGameName = (data) => {
  if (data && Object.keys(data).length > 0) {
    if (data?.game_code) {
      return data.game_code;
    }
  }
};

export const getPromptText = (data) => {
  if (data && Object.keys(data).length > 0) {
    if (data?.game_state?.prompt) {
      let promptText = data.game_state.prompt.replace(/\[BLANK]/g, "____");
      promptText = promptText.replace(/<br\s*\/?>/gm, "\n");
      return promptText;
    } else {
      return "";
    }
  }
};

export const createNewRoom = (gameObj) => {
  const storeState = store.getStore().getState();
  const game_reducer = storeState?.gameReducer;
  const socket_reducer = storeState?.socketReducer;
  const wellnessData = game_reducer?.wellnessParamsObject;
  console.log(wellnessData, "wellnessDatawellnessDatawellnessData");
  console.log(gameObj, "gameObjgameObjgameObj");
  let currentUserId = "HOST_USER1";
  let profileImage = "profileimage";
  let displayName = "HOST";
  if (gameObj && gameObj.currentUser && gameObj.currentUser.userId) {
    currentUserId = gameObj.currentUser.userId;
    displayName = gameObj.currentUser.username;
    if (gameObj.currentUser.picture) {
      profileImage = gameObj.currentUser.picture;
    }
  }
  let data = {};

  if (gameObj.gameName === "WELL") {
    data = {
      action: "create-room",
      displayName: displayName,
      userId: currentUserId,
      profileImage: profileImage,
      gameCode: gameObj.gameName,
      hero_img: wellnessData?.hero_img,
      title: wellnessData?.title,
      teamCode: game_reducer?.sessionObj?.id,
      sessionId: game_reducer?.sessionObj?.session_id,
      description: wellnessData?.description,
      edition: wellnessData?.edition,
      theme_color: wellnessData?.theme_color
    };
  } else if (!_.isEmpty(socket_reducer?.LT)) {
    data = {
      action: "create-room",
      displayName: displayName,
      userId: currentUserId,
      profileImage: profileImage,
      gameCode: gameObj.gameName,
      background: socket_reducer?.LT?.background,
      background_mobile: socket_reducer?.LT?.background_mobile,
      top_logo: socket_reducer?.LT?.top_logo,
      top_logo_mobile: socket_reducer?.LT?.top_logo_mobile,
      teamCode: game_reducer?.sessionObj?.id,
      sessionId: game_reducer?.sessionObj?.session_id
    };
  } else {
    data = {
      action: "create-room",
      displayName: displayName,
      userId: currentUserId,
      profileImage: profileImage,
      gameCode: gameObj.gameName,
      teamCode: game_reducer?.sessionObj?.id,
      sessionId: game_reducer?.sessionObj?.session_id
    };
  }

  const session_obj = storeState?.gameReducer?.sessionObj || {};
  if (session_obj?.session_id && session_obj.id) {
    data.sessionId = session_obj.session_id;
    data.teamCode = session_obj.id;
  }

  if (gameObj.gameName === "TOT") {
    data.subscriptionRequired = true;
  }
  if (localStorage.getItem("work_game") === "CHPTW") {
    data.edition = "CHPTW";
  }
  if (localStorage.getItem("work_game") === "GAHW") {
    data.edition = "GAHW";
  }
  if (localStorage.getItem("work_game") === "GAHF") {
    data.edition = "GAHF";
  }
  Socket.sendMessage(data);
};

export const removeUser = (roomObj, data) => {
  let dataObj = {
    action: "remove-user",
    roomId: roomObj.id,
    playerId: data.player_id,
    displayName: data.display_name
  };
  Socket.sendMessage(dataObj);
};

export const generateBranchUrl = (data) => {
  Socket.sendMessage(data);
};

export const end_Game = (data, props) => {
  localStorage.removeItem("utm_medium");
  localStorage.removeItem("utm_source");
  localStorage.removeItem("utm_campaign");
  localStorage.removeItem("utm_content");
  localStorage.removeItem("work_game");
  sessionStorage.removeItem("gameCode");
  localStorage.removeItem("webUrl");
  store.dispatch(setViewerWebUrl(false));
  store.dispatch(setGameName(""));
  store.dispatch(endGame(true));
  store.dispatch(emptyGameData({}));
  let socketdata = {
    action: "end-game",
    roomId: data.id
  };
  Socket.sendMessage(socketdata);
  props && props.history.push("/");
};
